<!-- <mat-select [formControl]="formControl" [formlyAttributes]="field">
    <mat-option *ngFor="let option of optionsAPI" [value]="option.value">{{ option.label }}</mat-option>
</mat-select> -->

<ng-template #loadingSelect>
    <mat-spinner></mat-spinner>
    <p>Loading options...</p>
</ng-template>
<div>
    <aw-file-input (fileLoaded)="handleFileLoaded()"></aw-file-input>
</div>
<ng-container>
    <mat-form-field>
        <mat-label *ngIf="to.label">{{ to.label }}</mat-label>
        <mat-select [formControl]="formControl" [formlyAttributes]="field" [placeholder]="to.placeholder">
          <mat-option *ngIf="optionsAPI.length === 0" disabled>No options available</mat-option>
          <mat-option *ngFor="let option of optionsAPI" [value]="option.name">{{ option.name + ', ' + option.lastModified }}</mat-option>
        </mat-select>
        <mat-hint *ngIf="to.description">{{ to.description }}</mat-hint>
    </mat-form-field>
</ng-container>